import React from 'react';
import { View } from 'react-native';

import CreateAccount from './Create';

const AccountDocs = () => {
  return (
    <View>
      <CreateAccount />
    </View>
  );
};

export default AccountDocs;
